/** Strategem 325 (Oblivion Pulse) — shockwave + targeting cue */
export const OBLIVION_PULSE_SOUND_PATH = '/sounds/pulse_target.mp3';
